import { useCallback } from 'react'
import { LRMainReason, LRReasonId } from '../constant'

const useGetLRReason = ({ item, getSteps }) => useCallback(async step => {
  const { poCompletionDate } = { ...item }
  const isLifetimeReplacement = true

  try {
    const { data } = await getSteps(step, poCompletionDate, isLifetimeReplacement)
    const { widgets } = { ...data }
    const { options, id: parent, title } = widgets.find(widget => widget.id === LRMainReason)
    const { id, label, value } = options.find(option => option.id === LRReasonId)
    return {
      parent,
      title,
      id,
      label,
      value,
    }
  } catch (error) {
    console.log('LR: error getting steps', error)
    return null
  }
}, [item, getSteps])

export default useGetLRReason
